import type { IconNode } from '../types';

/**
 * @name life-jacket
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTRhMi41IDIuNSAwIDAgMC0uOC0xLjkgMy41IDMuNSAwIDEgMSA1LjYgMGwtLjMuNEEyLjUgMi41IDAgMCAwIDE0IDE0djVhMyAzIDAgMSAwIDYgMHYtOWE4IDggMCAwIDAtMTYgMHY5YTMgMyAwIDEgMCA2IDBaIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/life-jacket
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const lifeJacket: IconNode = [
  [
    'path',
    {
      d: 'M10 14a2.5 2.5 0 0 0-.8-1.9 3.5 3.5 0 1 1 5.6 0l-.3.4A2.5 2.5 0 0 0 14 14v5a3 3 0 1 0 6 0v-9a8 8 0 0 0-16 0v9a3 3 0 1 0 6 0Z',
      key: '1onx1t',
    },
  ],
];

export default lifeJacket;
